var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-layout",attrs:{"id":"admin-layout"}},[(_vm.showSidebar)?_c('Sidebar'):_vm._e(),_c('Head',{attrs:{"page":_vm.$route.name}}),_c('router-view'),_c('Footer',{attrs:{"page":_vm.$route.name,"showLogout":_vm.showSidebar}}),_c('ConfirmCart'),_c('EmptyCart'),_c('AlertCart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }